import Configuracao from "../misc/Configuracao";
import { GraphQL } from "../modelo/GraphQL";
import { ProcessoExterno, ProcessoExternoDto } from "../modelo/ProcessoExterno";
import { StatusImportacao } from "../modelo/StatusImportacao";
import MensagemStore from "../store/MensagemStore";
import { apresentarApiErroPadrao } from '@/utils/ApiErroPadraoUtils';
import fetch from "./AxiosAdapter";


class ImportacaoApi {
    carregarProcessosParaImportar = async (gabinete: string): Promise<ProcessoExterno[]> => {
        const result = await fetch<ProcessoExterno[]>(Configuracao.urlGetImportacao.replace('{SIGLA_GABINETE}', gabinete));
        return result.data;
    }

    carregarProcessosParaImportarGraphql = async (gabinete: string): Promise<ProcessoExternoDto[]> => {

        const result = await fetch<GraphQL<ProcessoExternoDto[]>>(Configuracao.urlGraphql, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: {
                "query": `{
                    processosParaImportar(gabinete: "${gabinete}") {
                        identificadorProcesso
                        numeroProcesso
                        classe
                        dataAutuacao
                        prioridades
                        origem
                        relator {
                            nome
                            sigla
                        }
                        orgaoJulgador {
                            sigla
                            descricao
                        }
                        orgaoJulgadorColegiado {
                            sigla
                            descricao
                        }
                        classes {
                            descricao
                            sigla
                            codigo
                        }
                    }
                }`
            }
        });
        if (!result.data.data) {
            if (!apresentarApiErroPadrao((result as any).errors)) {
                MensagemStore.apresentarErro("Erro ao carregar processos para importar ");
            }
            console.error((result as any).errors);
        }
        return result.data.data.processosParaImportar || [];
    }

    importarProcessos = async (numerosDeProcesso: string[], oriegemImportacaoGE: string, cpfServidor: string, numeroControleGab: number): Promise<string> => {
        const url = this.construirUrlImportacao(null, oriegemImportacaoGE, cpfServidor, numeroControleGab);

        const result = await fetch<string>(url,
            {
                method: 'POST',
                body: numerosDeProcesso
            });
        return result.data;
    }

    importarProcesso = async (numeroDeProcesso: string, oriegemImportacaoGE: string): Promise<string> => {
        const url = this.construirUrlImportacao(numeroDeProcesso, oriegemImportacaoGE);

        const result = await fetch<string>(url,
            {
                method: 'POST'
            });
        return result.data;
    }
    verificarProcessosImportados = async (codImportacao: string): Promise<StatusImportacao[]> => {
        const result = await fetch<StatusImportacao[]>(Configuracao.urlProcessosImportados.replace("{COD_IMPORTACAO}", codImportacao));
        return result.data;
    }

    construirUrlImportacao = (numeroDeProcesso: string, origemImportacaoGE: string, cpfServidor?: string, numeroControleGab?: number): string => {
        let url = Configuracao.urlFazerImportacao;
        if (numeroDeProcesso) { // Adiciona o número do processo se for fornecido
            url += "/" + numeroDeProcesso;
        }

        url += '?origemRequisicaoImportacaoGE=' + origemImportacaoGE;

        if (cpfServidor) {
            url += '&cpfServidor=' + cpfServidor;
        }

        if (numeroControleGab) {
            url += '&numeroControleGab=' + numeroControleGab;
        }
        return url;
    };

}

export default new ImportacaoApi();